import "./LinkHeroFrontpage.scss";
import cn from "classnames";
import { LinkProps } from "/Models/Generated/LinkProps";
import { ColorTheme } from "/Models/Models/ColorTheme";

export interface LinkWithIconProps {
  colorTheme?: ColorTheme;
  hasUnderline?: boolean;
  tabIndex?: number;
  contained?: boolean;
}

export interface ExtendedLinkProps extends LinkWithIconProps, LinkProps {}

const Link = ({ href, target, text, tabIndex }: ExtendedLinkProps) => {
  if (href) {
    return (
      <div className="link-hero-frontpage-norad">
        <a
          className={cn("link-hero-frontpage-norad__container")}
          {...{ target, href }}
          tabIndex={tabIndex}
        >
          <span className="link-hero-frontpage-norad__container__text">
            {text}
          </span>
        </a>
      </div>
    );
  }
};

export default Link;
